/** The methods listed below are global methods available
 *  under Vue.$app.methodName(), e.g. this.$app.getToken()
 */
import Vue from "vue";
import { store } from "@/store/store";
import { config } from "@/config.js";
import Buefy from "buefy";
import globals from "./globals.js";

Vue.use(Buefy);

export default {
  editToken(val) {
    store.commit("app/EDIT_AMADEUS_TOKEN", val);
  },
  async getToken() {
    let sol = {};
    let raw = { environment: config.amadeusEnvironment };

    try{
      let result = await this.$app.huddleLabsServerCall("amadeus/access-token", raw);
      if(result.access_token){
        sol.access_token = result.access_token;
      }
    }
    catch(error){
      sol.error = error;
    }

    return sol;
  },
  setSessionKey(key) {
    store.dispatch("app/alterSession", key);
  },
  logout() {
    // console.log("logout");
    //localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("loginExpireTime");
    store.dispatch("clearState/clearState");
  },
  isMobileVersion() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  huddleLabsApi(path = null, body = null, headers = {}, additionalData = []) {
    let baseUrl = config.huddlelabsApiBaseUrl;
    let username = config.huddlelabsApiUsername;
    let password = config.huddlelabsApiPassword;
    let basicAuth = btoa(username + ":" + password);

    let fullUrl;

    if (path) {
      fullUrl = baseUrl + path;
    } else {
      fullUrl = baseUrl;
    }

    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Basic ${basicAuth}`);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Requested-With", "XMLHttpRequest");

    let urlencoded = new URLSearchParams();
    urlencoded.append("environment", "production");

    for (const val of Object.keys(headers)) {
      myHeaders.append(val, headers[val]);
    }

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    if (body) {
      requestOptions.body = JSON.stringify(body);
    }

    let responseBody;
    
    fetch(`${fullUrl}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        responseBody = JSON.parse(result);
      })
      .catch((error) => {
        responseBody = null;
      });

    return responseBody;
  },
  async huddleLabsServerCall(type = null, body = null, headers = {}, additionalData = []) {
    let baseUrl = config.huddlelabsApiBaseUrl;
    let username = config.huddlelabsApiUsername;
    let password = config.huddlelabsApiPassword;
    let basicAuth = btoa(username + ":" + password);

    let fullUrl;

    if (type) {
      fullUrl = baseUrl + type;
    } else {
      fullUrl = baseUrl;
    }

    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Basic ${basicAuth}`);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Requested-With", "XMLHttpRequest");

    let urlencoded = new URLSearchParams();
    urlencoded.append("environment", "production");
    for (const val of Object.keys(headers)) {
      myHeaders.append(val, headers[val]);
    }

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    if (body) {
      if(body)
      requestOptions.body = JSON.stringify(body);
     // requestOptions.body = body;

    }

    //// console.log('requestOptions: ', requestOptions);

    let sol;
    await fetch(`${fullUrl}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        // // console.log('API result:', result);
        sol = JSON.parse(result);
        sol.error = false;
      })
      .catch((error) => {
        // console.log('error', error);
        sol = { error: true };
      });
    return sol;
  },

  //Form Data Calls
  async huddleLabsServerCall1(
    type = null,
    body = null,
    headers = {},
    additionalData = []
  ) {
    let baseUrl = config.huddlelabsApiBaseUrl;
    let username = config.huddlelabsApiUsername;
    let password = config.huddlelabsApiPassword;
    let basicAuth = btoa(username + ":" + password);

    let fullUrl;

    if (type) {
      fullUrl = baseUrl + type;
    } else {
      fullUrl = baseUrl;
    }

    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Basic ${basicAuth}`);
    myHeaders.append("X-Requested-With", "XMLHttpRequest");

    let urlencoded = new URLSearchParams();
    urlencoded.append("environment", "production");
    for (const val of Object.keys(headers)) {
      myHeaders.append(val, headers[val]);
    }

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      processData: false

    };

    if (body) {
    //  requestOptions.body = JSON.stringify(body);
      requestOptions.body = body;

    }

    //// console.log('requestOptions: ', requestOptions);

    let sol;
    await fetch(`${fullUrl}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        // console.log('API result:', result);
        sol = JSON.parse(result);
        sol.error = false;
      })
      .catch((error) => {
        // console.log('error', error);
        sol = { error: true };
      });
    return sol;
  },
  //
  getCurrentAppVersion() {
    store.dispatch('app/getCurrentAppVersion');
  },
  refreshBrowser() {
    store.dispatch('app/refreshBrowser');
  },
  reloadApp(){
    if (localStorage.getItem('reloaded')) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem('reloaded');
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem('reloaded', '1');
      this.refreshBrowser();
    }

  }
};
